const ExplainerConfig = {
	sortedExplainers:[{
		key: 'timelineIntro',
		icon: 'sheetViewTimeline',
		title: 'What is a Timeline View?',
		image: require('assets/explainer/2021_W28_timelineExplainer.png'),
		ctaText: 'Learn more',
		hookText: 'View your records organized by owner, team, theme, and more.',
		criteria(){
			return false;
			/*
			NOTE: This contextual explainer was turned off in favor of a user action explainer for timeline.
			The conditional logic left here should serve as a starting point for future explainers.

			const exSelf = this;
			if(exSelf.$root.systemState.experience !== 'desktop'){
				//Don't show on mobile
				return false;
			}

			if(exSelf.workbookState && exSelf.workbookState.activeSheetView){

				if(exSelf.workbookState.activeSheetView.type !== "timeline"){
					// only show on timeline
					return false;
				}

				if(exSelf.workbookState.activeSheetView.sheetViewGroup.dataStore){
					if(exSelf.workbookState.activeSheetView.sheetViewGroup.dataStore.meta.showOnboarding && exSelf.workbookState.activeSheetView.sheetViewGroup.dataStore.meta.onboardingType && exSelf.workbookState.activeSheetView.sheetViewGroup.dataStore.meta.onboardingType === 'wizard'){
						if(exSelf.workbookState.activeSheetView.sheetViewGroup.dataStore.meta.dataStoreWizard.properties === undefined || !exSelf.workbookState.activeSheetView.sheetViewGroup.dataStore.meta.dataStoreWizard.properties.complete){
							// dont show if we have the wizard open
							return false;
						}
					}
					let sheetConfig = exSelf.workbookState.activeSheetView.getOrCreateDisplayConfigurator();
					if(sheetConfig.dateLastConfigured === null){
						// dont show if we have the configurator open
						return false;
					}
				}
				else{
					// dont show if we cant determine the dataStore
					return false;
				}
			}
			else{
				// dont show if we dont have the workbook state/active sheet view
				return false;
			}

			if(exSelf.userPrefrences && exSelf.userPrefrences.explainer.explainerStates['timelineIntro']){
				if(exSelf.userPrefrences.explainer.explainerStates['timelineIntro'].dismissed === true){
					// dont show if the user has dismissed this
					return false;
				}
			}
			else{
				// dont show if we dont have the user preferences for explainerStates/timelineIntro
				return false;
			}

			return true;
			*/
		},
		ctaOnClick(sheetView){
			const exSelf = this;
			exSelf.knowledgeGuideOpen = true;
			exSelf.$pubsub.modules.knowledgeGuide.pub('openGuide', {
				article: 'timelineIntro',
				sheetView: sheetView,
			});
		}
	}]
}


export default ExplainerConfig;
